import React from "react";
import {useTranslation} from "react-i18next";
import Button from "../../Common/Button";
import QuickPeriodSelector from "./QuickPeriodSelector";
import {
    Activity,
    Clock,
    Calendar,
    BarChart2,
    Upload,
    UsersIcon,
    RefreshCw,
    GitCompare
} from "lucide-react";

const PageHeader = ({
                        tabs,
                        active,
                        setActive,
                        handlePopupToggle,
                        isDarkMode,
                        isDropdownOpen,
                        setIsDropdownOpen,
                        selectedPeriodLabel,
                        setSelectedPeriodLabel,
                        setDateRange,
                        onRefresh,
                        isRefreshing = false,
                        onCompareClick,
                        comparePeriodControl = null,
                        productFilterControl = null,
                    }) => {
    const {t} = useTranslation("activite");
    const tabIcons = {
        resumer: <Activity size={22} strokeWidth={2} className="mr-2 transition-colors duration-200"/>,
        journaux: <Clock size={22} strokeWidth={2} className="mr-2 transition-colors duration-200"/>,
        calendar: <Calendar size={22} strokeWidth={2} className="mr-2 transition-colors duration-200"/>,
        ventes: <BarChart2 size={22} strokeWidth={2} className="mr-2 transition-colors duration-200"/>,
        employee: <UsersIcon size={22} strokeWidth={2} className="mr-2 transition-colors duration-200"/>
    };

    return (
        <header className={isDarkMode ? 'bg-gray-900' : 'bg-white'}>
            <div className={`px-4 sm:px-8 py-0 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                <div className="flex flex-col items-center">
                    <div className="hidden sm:flex w-full justify-between items-center mb-2">
                        <h1 className={`text-xl font-semibold text-center w-full mt-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                            {t("pageHeader.title")}
                        </h1>
                    </div>
                    <div className="flex w-full justify-end items-center mb-2 gap-1 sm:gap-2">
                        {/* Export buttons on the right */}
                        <div className="flex items-center gap-1 sm:gap-2">
                            <QuickPeriodSelector
                                isOpen={isDropdownOpen}
                                setIsOpen={setIsDropdownOpen}
                                selectedPeriod={selectedPeriodLabel}
                                setSelectedPeriod={setSelectedPeriodLabel}
                                setDateRange={setDateRange}
                                isDarkMode={isDarkMode}
                            />
                            {/* Refresh button */}
                            {onRefresh && (
                                <Button variant="plain" icon={RefreshCw} loading={isRefreshing} title={t("pageHeader.refresh")} onClick={onRefresh}/>
                            )}
                             {/* Export button */}
                            <Button variant="plain" icon={Upload} compact onClick={handlePopupToggle}>
                                {t("pageHeader.export")}
                            </Button>
                            {/* Filtre Produits / Catégories (Résumé) */}
                            {productFilterControl}
                            {/* Period comparison (previous period / N-1) */}
                            {comparePeriodControl}
                            {/* Compare button */}
                            {onCompareClick && (
                                <Button variant="plain" icon={GitCompare} compact onClick={onCompareClick}>
                                    {t("compareAccounts.button")}
                                </Button>
                            )}
                    </div>
                </div>

                <div className="flex overflow-x-auto no-scrollbar w-full md:justify-center">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`px-3 sm:px-4 py-2 flex items-center transition-all whitespace-nowrap flex-shrink-0 border-b-2 ${
                                active === tab.key
                                    ? 'text-primary border-primary'
                                    : isDarkMode 
                                        ? 'text-gray-400 border-transparent hover:text-gray-300 hover:border-gray-600' 
                                        : 'text-gray-600 border-transparent hover:text-gray-700 hover:border-gray-300'
                            }`}
                            onClick={() => setActive(tab.key)}
                        >
                                <span className="hidden sm:block">{tabIcons[tab.key]}</span>
                                <span className="text-sm sm:text-base text-light">{tab.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default PageHeader;
